import { gql } from '@apollo/client';

export const HIGO_PAY_TOKEN_STATUS = gql`
  query HigoPayTokenStatus($token: String!) {
    higoPayTokenStatus(token: $token) {
      valid
    }
  }
`;
